module.exports = __webpack_public_path__ + "static/img/8.ff6d684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/8.png
// module id = O0r8
// module chunks = 0